const WasteManagementExternalArticlesReportSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2776_37942)" />
      <path
        d="M22.6203 22.0101H30.156C30.7111 22.0101 31.1611 21.5601 31.1611 21.0051C31.1611 20.45 30.7111 20 30.156 20H22.6203C22.0652 20 21.6152 20.45 21.6152 21.0051C21.6152 21.5601 22.0652 22.0101 22.6203 22.0101Z"
        fill="white"
      />
      <path d="M28.4692 32.7755H32.7754V39.3777H28.4692V32.7755Z" fill="white" />
      <path
        d="M32.7755 41.3878H27.4643C26.9092 41.3878 26.4592 40.9378 26.4592 40.3827V31.7705C26.4592 31.2154 26.9092 30.7654 27.4643 30.7654H32.7747C32.7597 29.0466 32.0835 27.4326 30.8663 26.2154C30.2539 25.6031 29.8407 24.8453 29.6562 24.0204H23.1193C22.9348 24.8453 22.5216 25.6031 21.9092 26.2154C20.678 27.4466 20 29.0833 20 30.8242V43.6838H32.7755V41.3878Z"
        fill="white"
      />
      <path
        d="M43.6841 31.7704V43.6837H50.0004V31.7704C50.0004 31.6143 49.964 31.4605 49.8942 31.3209L47.8473 27.227V23.1581C47.8473 22.6031 47.3973 22.1531 46.8423 22.1531C46.2872 22.1531 45.8372 22.6031 45.8372 23.1581V27.227L43.7902 31.3209C43.7204 31.4604 43.6841 31.6143 43.6841 31.7704Z"
        fill="white"
      />
      <path
        d="M41.9924 30.4217L42.9685 28.4694H36.6036L35.4556 30.7654H41.8472C41.8886 30.6479 41.9367 30.533 41.9924 30.4217Z"
        fill="white"
      />
      <path
        d="M43.8267 23.1581C43.8267 22.8058 43.888 22.4677 43.9996 22.1531H38.2297C37.6746 22.1531 37.2246 22.6031 37.2246 23.1581V26.4592H43.8267V23.1581Z"
        fill="white"
      />
      <path d="M35.0718 32.7755H41.6739V43.6838H35.0718V32.7755Z" fill="white" />
      <path
        d="M51.1482 45.6938H18.8522C18.2972 45.6938 17.8472 46.1438 17.8472 46.6989V48.9949C17.8472 49.55 18.2972 50 18.8522 50H51.1482C51.7033 50 52.1533 49.55 52.1533 48.9949V46.6989C52.1533 46.1438 51.7033 45.6938 51.1482 45.6938Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2776_37942"
          x1="-1.56654e-06"
          y1="4.96155"
          x2="70"
          y2="66.9615"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E5A100" />
          <stop offset="1" stop-color="#F14B12" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default WasteManagementExternalArticlesReportSubcategory
